<template>
  <v-container fluid>
    <v-form ref="form">
      <v-row justify="left" align-content="center" dense>
        <v-col cols="2">
          <img :src="item.icon" width="60" />
        </v-col>

        <v-col cols="10">
          <v-row dense>
            <v-col cols="11">アプリID: {{item.app_id}}</v-col>
          </v-row>
        </v-col>


        <v-col cols="10" sm="10" md="10">
          <v-text-field dense v-model="item.twitter" :counter="100" label="TwitterID ( 例： romasaga_rs )"></v-text-field>
        </v-col>

        <v-col cols="2" sm="2" md="2">
          <a :href="'https://twitter.com/'+item.twitter" target="_blank">確認</a>
        </v-col>


        <v-col cols="12" sm="12" md="12">
          <v-text-field dense v-model="item.title" :counter="300" label="アプリタイトル"></v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <v-text-field dense v-model="item.sub_title" :counter="300" label="略称（検索用)"></v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <div style="color:red">{{itunesJson(item.itunes_json || null)}}</div>
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <v-text-field dense v-model="item.release" :counter="300" label="リリース日"></v-text-field>
        </v-col>

        <v-col cols="10" sm="10" md="10">
          <v-text-field dense v-model="item.article_url" :counter="300" label="AppMedia記事URL"></v-text-field>
        </v-col>

        <v-col cols="2" sm="2" md="2">
          <a :href="item.article_url" target="_blank">確認</a>
        </v-col>

        <v-col cols="10" sm="10" md="10">
          <v-text-field dense v-model="item.link_ios" :counter="300" label="iOSのストアリンク"></v-text-field>
        </v-col>

        <v-col cols="2" sm="2" md="2">
          <a :href="item.link_ios" target="_blank">確認</a>
        </v-col>

        <v-col cols="10" sm="10" md="10">
          <v-text-field dense v-model="item.link_android" :counter="300" label="Androidのストアリンク"></v-text-field>
        </v-col>

        

        <v-col cols="2" sm="2" md="2">
          <a :href="item.link_android" target="_blank">確認</a>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>


<script>
export default {
  name: "appli-detail",
  props: ["item"],

  methods: {
    itunesJson(data) {
      if (data != null) {
        const obj = JSON.parse(data);
        console.log(obj["results"][0]);

        return "JSON保存済み"
      }

      // console.log(obj["results"]);
    }
  }
};
</script>